import { serverApiEndpoint, directApiEndpoint } from './uris'
import * as featureFlags from './featureFlags'

const graphQLEndpoint = (): string => {
  return featureFlags.USE_SSO ? serverApiEndpoint : directApiEndpoint
}

export default graphQLEndpoint
